import request from '@/shared/api/request';

/**
 * Returns the list of teams.
 * @returns {Promise}
 * @param {string} uuid - A team uuid
 * @param {string} token - A token that was provided in the email link
 */
export const acceptInvite = (uuid: string, token: string): Promise<unknown> =>
  request({
    url: `/account/teams/${uuid}/invite/${token}/accept/`,
    method: 'GET',
  });
